import Global from '../store/global-selectors';
import { connect } from 'react-redux';
import get from 'lodash.get';
import * as Actions from '../store/shipments/filtering/shipments.filtering.actions';
import { DeleteFilterViewModal } from '../components/modals/delete-filterview-modal';

const mapStateToProps = (state) => {
  return {
    filterViewToDelete: Global.selectShipmentsFilteringActiveFilterView(state),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const closeModal = get(props, 'modalFrameworkMethods.closeModal');
  return {
    deleteFilterViewRequest: (filterViewToDelete) => {
      dispatch(Actions.deleteFilterViewRequest(filterViewToDelete));
      closeModal();
    },
  };
};

export const DeleteShippingFilterviewModalContainer = connect(mapStateToProps, mapDispatchToProps)(DeleteFilterViewModal);
